<template>
    <div class="contain15">
        <div class="contain-boxt">
            <div class="contain-left">
                <div class="contain-right-user" @click="isok1">
                    <img :src="this.$store.getters.getUserInfo.avatar" alt="">
                    <div class="contain-right-user-msg" v-if="this.$store.getters.getUserInfo.nickname">
                        <div class="contain-right-user-msg-name">{{this.$store.getters.getUserInfo.nickname}}</div>
                        <div class="contain-right-user-msg-id">ID：{{this.$store.getters.getUserInfo.id}}</div>
                    </div>
                    <div class="contain-right-user-msg" v-else>
                        <h4>请先登录</h4>
                    </div>
                </div>
                <el-menu
                    :router="true"
                    :default-active="defaultActive"
                    :unique-opened='true'
                    class="el-menu-vertical-demo"
                    >
                    <!-- <el-menu-item index="/mine/my_wallet/consumption">
                        <i class="el-icon-wallet"></i>
                        <span slot="title">我的钱包</span>
                    </el-menu-item> -->
                    <el-submenu index="/mine/my_community/my_attention" is-opened>
                        <template slot="title"><i class="el-icon-menu"></i><span>我的社区</span></template>
                        <el-menu-item index="/mine/my_community/my_attention">我的关注</el-menu-item>
                        <el-menu-item index="/mine/my_community/follow_my">关注我的</el-menu-item>
                        <el-menu-item index="/mine/my_community/my_release">我的发布</el-menu-item>
                        <el-menu-item index="/mine/my_community/my_comments">我的评论</el-menu-item>
                        <el-menu-item index="/mine/my_community/my_collection">我的收藏</el-menu-item>
                    </el-submenu>
                    <el-submenu index="/mine/my_match/my_registration" is-opened>
                        <template slot="title"><i class="el-icon-s-grid"></i><span>我的赛事</span></template>
                        <el-menu-item index="/mine/my_match/my_registration">我的报名</el-menu-item>
                        <el-menu-item index="/mine/my_match/my_team">我的战队</el-menu-item>
                    </el-submenu>
                    <el-submenu index="/mine/my_study/my_homework" is-opened>
                        <template slot="title"><i class="el-icon-reading"></i><span>我的学习</span></template>
                        <el-menu-item index="/mine/my_study/my_homework">我的作业</el-menu-item>
                        <el-menu-item index="/mine/my_study/my_classroom">我的技能课程</el-menu-item>
                        <el-menu-item index="/mine/my_study/my_timetable">我的学历课程</el-menu-item>
                        <el-menu-item index="/mine/my_study/my_achievement">我的成绩</el-menu-item>
                        <!-- <el-menu-item index="/mine/my_study/question_bank">技能课程题库</el-menu-item> -->
                    </el-submenu>
                    <el-submenu index="/mine/my_study/question_bank" is-opened>
                        <template slot="title"><i class="el-icon-s-operation"></i><span>技能课程题库</span></template>
                        <el-menu-item index="/mine/my_study/question_bank">答题题库</el-menu-item>
                        <el-menu-item index="/mine/my_study/question_bank/record">答题记录</el-menu-item>
                    </el-submenu>
                    <el-submenu index="/mine/my_study/question_bank/examination" is-opened>
                        <template slot="title"><i class="el-icon-edit-outline"></i><span>模拟考试</span></template>
                        <!-- /mine/my_study/question_bank/examination -->
                        <el-menu-item index="/mine/my_study/question_bank/examination?type=1">随堂练习</el-menu-item>
                        <el-menu-item index="/mine/my_study/question_bank/examination?type=2">课后作业</el-menu-item>
                        <el-menu-item index="/mine/my_study/question_bank/examination?type=3">班级考试</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="contain-right">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import UploadList from '@/components/UploadList/index.vue'
import forumItem from '@/components/forum-item/index.vue'
import Utils from '@/utils/utils';
export default {
    components: {UploadList,forumItem},
    data(){
        return{
            defaultActive:"",
        }
    },
    mounted(){
        this.defaultActive=this.$route.path
    },
    methods:{
        isok1() {
            if(this.$store.getters.getUserInfo.nickname){
                return
            }
            Utils.$emit('isok',1);
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep.el-submenu.is-active > .el-submenu__title {
  color: #409eff !important;
}
/* icon图标也跟着变 */
::v-deep .el-submenu.is-active > .el-submenu__title i {
  color: #409eff !important;
}
.contain15{
    .contain-boxt{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .contain-left{
            position: fixed;
            left: 90px;
            width: 16.5%;
            height: 100vh;
            background: #FFFFFF;
            padding: 30px;
            .contain-right-user{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                // align-items: center;
                margin-bottom: 30px;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
                .contain-right-user-msg{
                    margin-left: 15px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .contain-right-user-name{
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #1E2134;
                    }
                    .contain-right-user-id{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #506176;
                    }
                }
            }
            .el-menu{
                border-right: none;
            }
            
        }
        .contain-right{
            width: 77%;
            padding: 18px 18px 18px 18px;
            // margin-left: 20px;
            .contain-right-menu{
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .contain-right-menu-box{
                    cursor: pointer;
                    width: 21%;
                    padding: 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    background: #FFFFFF;
                    border-radius: 8px;
                    height: 120px;
                    .contain-right-menu-box-left{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .balance{
                            font-size: 16px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #858585;
                        }
                        .balance-number{
                            font-size: 20px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #1E2134;
                            margin: 15px 0;
                        }
                        .go-recharge{
                            display: flex;
                            flex-direction: row;
                            justify-content:flex-start;
                            align-items: center;
                            span{
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #3D7EFF;
                            }
                            img{
                                width: 13px;
                                height: 13px;
                                margin-left: 8px;
                            }
                        }
                    }
                    img{
                        width: 66px;
                        height: 66px;
                    }
                }

            }
        }
    }
}
.el-menu-vertical-demo{

}
</style>